import { Button, ButtonProps } from "@chakra-ui/react";

interface PrimaryButtonProps extends ButtonProps {
  label: string;
}

export const PrimaryButton = ({ label, ...props }: PrimaryButtonProps) => {
  return (
    <Button
      bg="#1FCDFF"
      color="gray.600"
      fontWeight="700"
      fontSize="20px"
      h="60px"
      px={8}
      borderRadius="full"
      _hover={{ bg: "#1FCDFF" }}
      {...props}
    >
      {label}
    </Button>
  );
};
